// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__v9amQ","inputBox":"styles_inputBox__2YGdn","flexDirection":"styles_flexDirection__2uj5Q"};